import React from "react";
import { Link, useHistory } from "react-router-dom";

const LandingPage: React.FC = () => {
  const history = useHistory();
  return (
    <div
      style={{
        minHeight: "100vh",
        fontFamily: "'Poppins', sans-serif",
        background: "linear-gradient(135deg, #f5f6fa 0%, #e9ecef 100%)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header */}
      <header
        style={{
          width: "100%",
          background: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.03)",
          padding: "24px 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "0 32px",
          }}
        >
          <span
            style={{
              fontWeight: 700,
              fontSize: "1.7rem",
              color: "#0a0a23",
              letterSpacing: "1px",
            }}
          >
            DOCEX TAX
          </span>
          <nav>
            <Link
              to="/"
              style={{
                margin: "0 18px",
                color: "#0a0a23",
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              Home
            </Link>
            <Link
              to="/home"
              style={{
                margin: "0 18px",
                color: "#0a0a23",
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              Apply
            </Link>
            <Link
              to="#"
              style={{
                margin: "0 18px",
                color: "#0a0a23",
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              Additional Info
            </Link>
            <Link
              to="#"
              style={{
                margin: "0 18px",
                color: "#0a0a23",
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              Income
            </Link>
            <Link
              to="#"
              style={{
                margin: "0 18px",
                color: "#0a0a23",
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              Deductions
            </Link>
            <Link
              to="#"
              style={{
                margin: "0 18px",
                color: "#0a0a23",
                textDecoration: "none",
                fontWeight: 500,
              }}
            >
              Other
            </Link>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section
        style={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "60px 0 40px 0",
          background: "linear-gradient(120deg, #fff 60%, #f5f6fa 100%)",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
          }}
        >
          {/* Left: Text */}
          <div
            style={{
              flex: 1,
              minWidth: 320,
              padding: "0 32px",
            }}
          >
            <h1
              style={{
                fontSize: "2.8rem",
                fontWeight: 700,
                color: "#0a0a23",
                marginBottom: 24,
                lineHeight: 1.1,
              }}
            >
              File your Canadian taxes online with a professional for just{" "}
              <span style={{ color: "#007BFF" }}>CAD $70</span>
            </h1>
            <p
              style={{
                fontSize: "1.3rem",
                color: "#333",
                marginBottom: 32,
                lineHeight: 1.5,
              }}
            >
              Get a personalized tax filing experience with a tax professional.
              Start your income tax filing request online, or reach out for help
              at{" "}
              <a
                href="tel:6136007560"
                style={{
                  color: "#007BFF",
                  textDecoration: "underline",
                }}
              >
                613-600-7560
              </a>
              .
            </p>
            <button
              onClick={() => history.push("/home")}
              style={{
                padding: "16px 36px",
                fontSize: "1.2rem",
                borderRadius: "8px",
                backgroundColor: "#007BFF",
                color: "#fff",
                border: "none",
                fontWeight: 600,
                cursor: "pointer",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                marginBottom: 24,
              }}
            >
              Start Filing Now
            </button>
            <div
              style={{
                marginTop: 16,
                color: "#888",
                fontSize: "1rem",
              }}
            >
              <span>Secure. Simple. Professional.</span>
            </div>
          </div>
          {/* Right: Illustration/Graphic */}
          <div
            style={{
              flex: 1,
              minWidth: 320,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "0 32px",
            }}
          >
            <img
              src="https://images.unsplash.com/photo-1519125323398-675f0ddb6308?auto=format&fit=crop&w=600&q=80"
              alt="Tax Filing Illustration"
              style={{
                width: "100%",
                maxWidth: 420,
                borderRadius: "18px",
                boxShadow: "0 8px 32px rgba(0,0,0,0.07)",
                objectFit: "cover",
              }}
            />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section
        style={{
          background: "#fff",
          padding: "48px 0",
          borderTop: "1px solid #eee",
        }}
      >
        <div
          style={{
            maxWidth: 1100,
            margin: "0 auto",
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: 32,
          }}
        >
          <div
            style={{
              flex: "1 1 250px",
              minWidth: 250,
              padding: 16,
            }}
          >
            <h3
              style={{
                color: "#007BFF",
                fontWeight: 700,
                fontSize: "1.3rem",
                marginBottom: 12,
              }}
            >
              Professional Review
            </h3>
            <p style={{ color: "#333", fontSize: "1.1rem" }}>
              Every return is reviewed by a tax professional to maximize your
              refund and ensure accuracy.
            </p>
          </div>
          <div
            style={{
              flex: "1 1 250px",
              minWidth: 250,
              padding: 16,
            }}
          >
            <h3
              style={{
                color: "#007BFF",
                fontWeight: 700,
                fontSize: "1.3rem",
                marginBottom: 12,
              }}
            >
              Simple & Secure
            </h3>
            <p style={{ color: "#333", fontSize: "1.1rem" }}>
              Your data is encrypted and protected. Our process is easy and
              designed for all Canadians.
            </p>
          </div>
          <div
            style={{
              flex: "1 1 250px",
              minWidth: 250,
              padding: 16,
            }}
          >
            <h3
              style={{
                color: "#007BFF",
                fontWeight: 700,
                fontSize: "1.3rem",
                marginBottom: 12,
              }}
            >
              Transparent Pricing
            </h3>
            <p style={{ color: "#333", fontSize: "1.1rem" }}>
              Flat fee of CAD $70 per person. No hidden charges, no surprises.
            </p>
          </div>
          <div
            style={{
              flex: "1 1 250px",
              minWidth: 250,
              padding: 16,
            }}
          >
            <h3
              style={{
                color: "#007BFF",
                fontWeight: 700,
                fontSize: "1.3rem",
                marginBottom: 12,
              }}
            >
              Expert Support
            </h3>
            <p style={{ color: "#333", fontSize: "1.1rem" }}>
              Need help? Our tax experts are just a call or message away.
            </p>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer
        style={{
          background: "#f5f6fa",
          padding: "24px 0",
          textAlign: "center",
          color: "#888",
          fontSize: "1rem",
          borderTop: "1px solid #eee",
        }}
      >
        <div>
          &copy; {new Date().getFullYear()} DOCEX Tax. All rights reserved.
        </div>
        <div style={{ marginTop: 8 }}>
          <Link to="/" style={{ color: "#007BFF", margin: "0 10px" }}>
            Home
          </Link>
          <Link to="/home" style={{ color: "#007BFF", margin: "0 10px" }}>
            Apply
          </Link>
          <Link to="#" style={{ color: "#007BFF", margin: "0 10px" }}>
            Additional Info
          </Link>
          <Link to="#" style={{ color: "#007BFF", margin: "0 10px" }}>
            Income
          </Link>
          <Link to="#" style={{ color: "#007BFF", margin: "0 10px" }}>
            Deductions
          </Link>
          <Link to="#" style={{ color: "#007BFF", margin: "0 10px" }}>
            Other
          </Link>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
// No errors to fix, file is fine as is.
